import React, {useRef, useEffect} from 'react'
import PropTypes from 'prop-types'
import {withTheme} from 'emotion-theming'
import styled from '@emotion/styled'
import {css} from '@emotion/core'
import WidthContainer from '../../../components/WidthContainer'
import {ClipLoader} from 'react-spinners'

const RootContainer = styled(WidthContainer)`
	margin-top: 5rem;
	display: flex;
	// align-items: center;
	// justify-content: center;
`

const Title = styled.h2`

`

const EmbedContainer = styled.div`
	// width: 100%;
	.SFbox {
		width: 100% !important;
	}
`


function SignUpSection({className, theme}) {
	const reference = useRef(null)
	useEffect(() => {
		const script = document.createElement('script')
		script.src = 'https://cdn.membershipworks.com/mfm.js'
		script.async = true

		reference.current.appendChild(script)
	}, [])

	return <RootContainer id='options' className={className}>
		<Title></Title>
		<EmbedContainer ref={reference}>
			<div
				id="SFctr"
				className="SF"
				data-org="20385"
				data-ini="join"
				data-scl="0"
				data-sfi="1"
				style={css('position:relative;height:auto')}>
				<div id="SFpne" style={css('position:relative')}>
					<div class="SFpne"><ClipLoader color={theme.colors.main}/></div>
				</div>
				<div style={css('clear:both')}/>
			</div>
		</EmbedContainer>
	</RootContainer>
}

SignUpSection.propTypes = {
	className: PropTypes.string,
}

SignUpSection.defaultProps = {
	className: '',
}

export default withTheme(SignUpSection)
